export const getReportData = async (menu) => {
    const ApiURL = window.Links.ApiURL
    const authToken = localStorage.getItem("authToken")
    var data = []
    var isSuccess = false
    var requestOptions = {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${authToken}`
        },
        redirect: "follow",
    }
    await fetch(`${ApiURL}myReport/search/${menu}`, requestOptions)
        .then((response) => response.json())
        .then(result => {
            if (result.success) {
                data = JSON.parse(result.data)
                isSuccess = true
            }
        })
        .catch(error => console.log("error", error))
    return { data, isSuccess }
}

export const getselectGroup = async () => {
    const ApiURL = window.Links.ApiURL
    const authToken = localStorage.getItem("authToken")
    var myHeaders = new Headers()
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Authorization", `Bearer ${authToken}`);
    var data = []
    var isSuccess = false
    var requestOptions = {
        method: "GET",
        headers: myHeaders,
        redirect: "follow",
    }
    await fetch(`${ApiURL}myReport/selectGroup`, requestOptions)
        .then(response => response.json())
        .then(result => {
            if (result.success) {
                data = result.data
                isSuccess = true
            }
        })
        .catch(error => console.log("error", error))
    return { data, isSuccess }
}

export const GetSubGroupSummary = async (id) => {
    const ApiURL = window.Links.ApiURL
    const authToken = localStorage.getItem("authToken")
    var myHeaders = new Headers()
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Authorization", `Bearer ${authToken}`);
    var data = []
    var requestOptions = {
        method: "GET",
        headers: myHeaders,
        redirect: "follow",
    }
    await fetch(`${ApiURL}myReport/SubGroup/${id}`, requestOptions)
        .then(response => response.json())
        .then(result => {
            data = result.data

        })
        .catch(error => console.log("error", error))
    return data
}
